import {
    rus2engChars,
    eng2rusChars
} from "../classes/lang/rusKeyboard";

export function classOf(a) {
    return Object.prototype.toString.call(a).slice(8, -1);
}

export function isCollection(a) {
    return (
        isArray(a)
        && a.length === 1
        && isObject(a[0])
        || isArray(a)
        && a.length === 2
        && isObject(a[0])
        && isObject(a[1])
    );
}

export function isFileList(a) {
    return classOf(a) === "FileList" || isArray(a) && a.every(function(x) {
        return classOf(x) === "File";
    });
}

export function isFunction(a) {
    return typeof a === "function";
}

/**
 * determine Array type
 * @param a
 * @return {boolean}
 */
export function isArray(a) {
    return a instanceof Array;
    //return classOf( a ) == 'Array';
}

export function isObject(a) {
    return typeof a === "object" && a !== null && !(a instanceof Array);
    //return classOf( a ) == "Object";
}

export function isObjOrArr(a) {
    return isObject(a) || isArray(a);
}

/**
 * determine String type
 * @param a
 * @return {Boolean}
 */
export function isString(a) {
    return typeof a === "string";
}

export function isNumber(a) {
    return typeof a === "number" && +a === a;
}

export function isTypeWithParams(a) {
    /*
        a === ['type', { ... }]
    */
    return isArray(a) && a.length === 2 && isString(a[0]) && isObject(a[1]);
}

export function isFile(a) {
    return a instanceof window.File || a instanceof window.Blob;
}

// проверяем является ли объект непосредственным наследником Object.prototype
export function isEasyObject(obj) {
    return isObject(obj) && obj.constructor.prototype === Object.prototype;
}

export function isArrayWithFuncs(arr) {
    if ( !isArray(arr) ) {
        return false;
    }

    for (let i = 0, n = arr.length; i < n; i++) {
        if ( !isFunction(arr[i]) ) {
            return false;
        }
    }

    return true;
}

export function isEvent(ev) {
    let out = false;
    if ( typeof jQuery !== "undefined" || typeof Events !== "undefined" ) {

        if ( typeof jQuery !== "undefined" ) {
            out = out || ev instanceof window.jQuery.Event;
        }

        if ( typeof Events !== "undefined" ) {
            out = out || ev instanceof window.Events;
        }
    }
    return out;
}

export function isNaN(a) {
    return typeof a === "number" && +a !== a;
}


export function isPrimitive(a) {
    return typeof a !== "object" && a !== null;
}

export function isDate(a) {
    return classOf(a) === "Date";
}

export function isDateDistance(a) {
    return isObject(a) && isNumber(+new Date(a.start)) && isNumber(+new Date(a.end));
}

export function isBoolean(a) {
    return typeof a === "boolean";
}

export function isArrayOfArrays(arr) {
    if ( !isArray(arr) ) {
        return false;
    }

    if ( arr.length === 0 ) {
        return false;
    }

    for (let i = 0, n = arr.length; i < n; i++) {
        if ( !isArray(arr[i]) ) {
            return false;
        }
    }

    return true;
}


export function round2(value, round) {
    if ( !isNumber(round) ) {
        return value;
    }

    let pow = Math.pow(10, round);
    return Math.round(value * pow) / pow;
}

export function floor2(value, round) {
    if ( !isNumber(round) ) {
        return value;
    }

    let pow = Math.pow(10, round);
    return Math.floor(value * pow) / pow;
}

export function ceil2(value, round) {
    if ( !isNumber(round) ) {
        return value;
    }

    let pow = Math.pow(10, round);
    return Math.ceil(value * pow) / pow;
}

//ВОЗНИК ВОПРОС ПО ПОВОДУ ПРАВИЛЬНОСТИ

// первая буква в верхнем регистре + trim
export function upFirstLetter(str) {
    str = str || "";// undefined, null => ""

    if ( !isString(str) ) {// custom objects and another
        str += "";
    }

    str = str.trim();
    /// (str[0] || "" ) пустая строка
    return (str[0] || "" ).toUpperCase() + str.slice(1);
}

// первая буква в верхнем регистре + trim
export function upFirstLetterAndLowerAll(str) {
    str = str || "";// undefined, null => ""

    if ( !isString(str) ) {// custom objects and another
        str += "";
    }

    str = str.trim().toLowerCase();
    /// (str[0] || "" ) пустая строка
    return (str[0] || "" ).toUpperCase() + str.slice(1);
}

// удобства под носом, расставил поля как тебе хочеться и получил конфиг
export function getFieldsProp(grid) {
    let fieldsProp = {};
    let contentWidth = grid.width;
    if ( grid.leftColumn ) {
        contentWidth -= grid.leftColumn.width;
    }
    grid.columns.getVisibleColumns().forEach(function(column) {
        let key = column.get("key");
        let width = column.get("width");
        let prop = width / contentWidth;

        fieldsProp[key] = prop;
    });

    let str = JSON.stringify(fieldsProp, null, 4);
    str = str.replace(/"/g, "");
    console.log(str);

    return fieldsProp;
}

export function getId(row) {
    let ID = row.ID;


    let _id = row._id;


    let id = row.id;

    if ( ID || ID === 0 ) {
        return ID;
    }
    if ( _id || _id === 0 ) {
        return _id;
    }
    if ( id || id === 0 ) {
        return id;
    }
}

export function setId(row, id) {
    row._id = row.ID = row.id = id + "";
    return row;
}

export function toUpperFields(row) {
    let value;


    let id = getId(row);

    for (let key in row) {
        value = row[key];
        delete row[key];
        key = key.toUpperCase();
        row[key] = value;
    }
    setId(row, id);

    return row;
}

export function getFocusGrid() {
    return window.$(".line.Grid.tab-focus").data("type-editor");
}

//  \ => /
export function normolizeURL(url) {
    url = url || "";
    return url.replace(/\\/g, "/");
}

export function formatBytes(bytes, decimals) {
    if ( !bytes ) return "0 Byte";
    let k = 1000; // or 1024 for binary
    let dm = decimals + 1 || 3;
    let sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    let i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}


export function br2n(str) {
    str = str || "";
    return str.replace(/<br[^>]*>/gi, "\n\r");
}

export function n2br(str) {
    str = str || "";
    return str
        .replace(/\n\r/g, "<br/>")
        .replace(/\n/g, "<br/>")
        .replace(/\r/g, "<br/>");
}

export function urlArgs2object(urlArgs) {
    return JSON.parse("{\"" + decodeURI(urlArgs).replace(/"/g, "\\\"").replace(/&/g, "\",\"").replace(/=/g, "\":\"") + "\"}");
}

// почти как currencySpaces,
// только без округления
export function addSpaces(str, options) {
    str = str.replace(/ /g, "");

    let afterPoint = str.split(".")[1] || "";
    let hasPoint = str.includes(".");
    str = str.split(".")[0];

    let symbols = str.split(""); let symb;
    let out = [];
    let minus = symbols[0] === "-" ? "-" : "";

    if ( minus ) {
        symbols.splice(0, 1);
    }
    let n = symbols.length; let x;

    if ( n > 3 ) {
        for (let i = n - 1; i >= 0; i--) {
            symb = symbols[i];
            x = n - i - 1;

            if ( x % 3 === 0 && x ) {
                out.push(" ");
            }

            out.push(symb);
        }
    } else {
        out = symbols.reverse();
    }


    out = minus + out.reverse().join("");

    // Когда вводят число в форме,
    // вызывается эта функция
    // ей на вход может поступить:
    // "103."
    // такие данные получаются,
    // когда пользователь пробует ввести дробное число
    // и только начал ее вводить, нажал на клаве Точку
    if ( hasPoint ) {
        out += ".";
    }

    if ( options && isNumber(options.float) ) {
        if ( !hasPoint ) {
            out += ".";
        }

        afterPoint = afterPoint.slice(0, options.float);
        const needZerosCount = options.float - afterPoint.length;
        for (let i = 0; i < needZerosCount; i++) {
            afterPoint += "0";
        }
        out += afterPoint;
    }

    else if ( afterPoint ) {
        afterPoint += "";
        out += afterPoint;
    }

    return out;
}

// 1 участник, 2 участника, 5 участников
export function number2postfixIndex(numb) {
    if ( !numb ) { // 0
        return 5;
    }

    let postfixIndex = 5;
    if (
        /^[^1]?1$/.test(numb)
    ) {
        postfixIndex = 1;
    } else if (
        /^[^1]?[234]$/.test(numb)
    ) {
        postfixIndex = 2;
    }

    return postfixIndex;
}

export function addZero(numb, length = 2) {
    // null, undefined, NaN, invalid string ("xxx", "asd")
    if ( numb == null || isNaN(+numb) ) {
        return "";
    }

    // every valid number
    numb = +numb;
    numb = numb + "";

    for (let i = numb.length; i < length; i++) {
        numb = "0" + numb;
    }

    return numb;
}

export function normolizeIsKey(isKey) {
    if ( isKey.slice(0, 3).toLowerCase() == "not" ) {
        // могут быть ошибки с методом isNot
        throw new Error("invalid 'is' name: ", isKey);
    }

    isKey = isKey.replace(/^is(Not)?/, "");
    isKey = isKey[0].toLowerCase() + isKey.slice(1);

    if ( isKey == "add" ) {
        throw new Error("isAdd reserved");
    }

    return isKey;
}


export function rus2eng(search) {
    if ( !isNumber(search) ) {
        search = search + "";
    }
    if ( !isString(search) ) {
        return "";
    }

    for (let alpha in rus2engChars) {
        search = search.replace(new RegExp(alpha, "gi"), rus2engChars[alpha]);
    }

    return search;
}

export function eng2rus(search) {
    if ( !isNumber(search) ) {
        search = search + "";
    }
    if ( !isString(search) ) {
        return "";
    }

    for (let alpha in eng2rusChars) {
        search = search.replace(new RegExp(alpha, "gi"), eng2rusChars[alpha]);
    }

    return search;
}

// calc can be:
// 110
// 110.5
// "110px"
// "110.5px"
// "100%"
// "22.5%"
// "calc( 100% - 110px)"
export function calcSize(calc, size) {
    if ( isNumber(calc) ) {
        calc = calc + "px";
    }

    if ( /^\s*\d+(\.\d+)?(%|px)\s*$/.test(calc) ) {
        calc = "calc( " + calc + " + 0px )";
    }

    if ( !/calc/.test(calc) ) {
        return NaN;
    }

    calc = calc.replace(/calc|\(|\)/ig, "");
    let splitted = calc.split(/[-+/*]/);


    let a = splitted[0];


    let b = splitted[1];

    if ( /%/.test(a) ) {
        a = parseFloat(a);
        a = size * ( a / 100 );
    } else {
        a = parseFloat(a);
    }

    if ( /%/.test(b) ) {
        b = parseFloat(b);
        b = size * ( b / 100 );
    } else {
        b = parseFloat(b);
    }

    if ( calc.indexOf("+") != -1 ) {
        return a + b;
    }
    else if ( calc.indexOf("-") != -1 ) {
        return a - b;
    }
    else if ( calc.indexOf("/") != -1 ) {
        return a / b;
    }
    else if ( calc.indexOf("*") != -1 ) {
        return a * b;
    }
}

let userLangModels = [];
export function setLangs(_userLangModels) {
    userLangModels = _userLangModels;
}

export function getLangs() {
    return userLangModels;
}

export function wrapText(text) {
    if ( text == null ) {
        return "null";
    }

    text += "";
    let tag = "tag";
    let index = 1;
    while (text.indexOf("$tag" + index + "$") !== -1) {
        index++;
    }
    tag += index;

    return `$${tag}$${text}$${tag}$`;
}
